const initialState = {
  studioSetup: {},
  communicationStudio: {},
  workflowStudio: {},
  assignmentStudio: {},
};

const collectionsOrchestrationEngine = (state = initialState, action) => {
  switch (action.type) {
    case "SET_STUDIO_SETUP":
      return {
        ...state,
        studioSetup: action.payload,
      };

    default:
      return state;
  }
};

export default collectionsOrchestrationEngine;
